<template>
  <div class="card">
    <div class="card-header">
      Donation logs
      <br>
      <small>Timeline of donation updates and changes (currently used for error handling)</small>
    </div>
    <div class="card-body">
      <div v-if="!logs || logs.length === 0">
        <em class="text-muted text-readable">No logs were found</em>
      </div>
      <ul v-else class="timeline">
        <li v-for="(log, index) in logs" class="step" :key="index">
          <h5 class="float-left text-capitalize" :class="{ 'text-warning': log.type === 'warning', 'text-error': log.type === 'error', 'text-success': log.type === 'status'}">{{ log.type }}</h5>
          <small class="float-right" :title="formatDateTime(log.created_at)">{{timeSinceTimestamp(log.created_at)}}</small>
          <br>
          <div class="text-readable small" style="color: lightgray">
            {{log.message}}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'StreamlabsTimeline',
  props: [
    'id',
  ],
  data() {
    return {
      logs: [],
    };
  },
  methods: {
    refresh() {
      axios.get(`/admin/services/streamlabs/transaction/${this.id}/logs`).then((response) => {
        const data = response.data || {};
        this.logs = data.logs || [];
      });
    },
    timeSinceTimestamp(ts) {
      return moment(ts).fromNow();
    },
    formatDateTime(ts) {
      return moment(ts).format('YYYY-MM-DD hh:mm');
    },
  },
  mounted() {
    this.refresh();
  }
};
</script>

<style lang="scss" scoped>
</style>
